import { useState } from "react";
import { Shield } from "@mui/icons-material";
import { Button, Checkbox, InputLabel } from "@mui/material";
import { Input } from "../ui/input";

import PhoneInputWithCountry from "../ui/PhoneInputWithCountry";
import { getOtpRequestCooldownMessage, isOtpRequestCooldownError, requestOtp, saveScoutSignupLead, stampOtpSessionData } from "../../services/otp";
import { emitSnackbar } from "../../lib/snackbar-emitter";
import manageErrors from "../../lib/error-management";

interface Step1Props {
  onNext: () => void;
  onLogin: () => void;
  setSession: (session_data: any) => void;
}

export let requestSession: () => Promise<void> = () => Promise.resolve()

const Step1AdminData = ({ onNext, onLogin, setSession }: Step1Props) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [newsletter, setNewsletter] = useState(false);
  const [loading, setLoading] = useState(false)

  const isValid = name.trim().length > 0 && email.includes("@") && phone.replace(/\D/g, "").length >= 10;

  const submit = async () => {
      setLoading(true)

      const payload = {
        telephone: phone,
        name: name,
        email: email,
        newsletter: newsletter
      }

      const leadResponse = await saveScoutSignupLead(payload)
      if (leadResponse.status !== 200) {
        emitSnackbar({message: manageErrors(leadResponse.data), severity: 'error'})
        setLoading(false)
        return
      }

      const response = await requestOtp(payload)
      if (response.status === 200) {
        const data = stampOtpSessionData(response.data, phone)
        setSession({
          ...data,
          adminData: { ...payload }
        })
        onNext()
      }
      else if (isOtpRequestCooldownError(response))
        emitSnackbar({message: getOtpRequestCooldownMessage(null, phone), severity: 'warning'})
      else
        emitSnackbar({message: manageErrors(response.data), severity: 'error'})

      setLoading(false)
  }

  requestSession = submit

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-xl font-bold text-foreground mb-2">Vamos criar sua conta de administrador

        </h1>
        <p className="text-sm text-muted-foreground">
          Leva menos de 1 minuto. Você poderá cadastrar o primeiro número para monitoramento em seguida.
        </p>
      </div>

      <div className="bg-card rounded-lg border border-border shadow-sm p-6 space-y-5">
        <div className="space-y-1.5">
          <InputLabel htmlFor="name" className="text-sm font-medium text-foreground">Nome completo</InputLabel>
          <Input
            id="name"
            placeholder="Digite seu nome completo"
            value={name}
            onChange={(e: any) => setName(e.target.value)} />

        </div>

        <div className="space-y-1.5">
          <InputLabel htmlFor="email" className="text-sm font-medium text-foreground">E-mail corporativo</InputLabel>
          <Input
            id="email"
            type="email"
            placeholder="seu@empresa.com.br"
            value={email}
            onChange={(e: any) => setEmail(e.target.value)} />

        </div>

        <div className="space-y-1.5">
          <InputLabel htmlFor="phone" className="text-sm font-medium text-foreground">WhatsApp do administrador</InputLabel>
          <PhoneInputWithCountry
            id="phone"
            value={phone}
            onChange={setPhone} />

          <p className="text-xs text-muted-foreground">
            Usaremos este número para enviar seu token de acesso seguro.
          </p>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox
            id="newsletter"
            checked={newsletter}
            onChange={({target}) => setNewsletter(!!target.checked)} />

          <InputLabel htmlFor="newsletter" className="text-sm text-muted-foreground cursor-pointer">
            Quero receber dicas e novidades por e-mail.
          </InputLabel>
        </div>

        <Button
          className="w-full"
          size="large"
          disabled={!isValid || loading}
          variant='contained'
          onClick={submit}>

        {loading ? 'Aguarde':'Continuar'}  
        </Button>

        <p className="text-center">
          <button type="button" className="text-sm font-medium text-accent hover:underline" onClick={onLogin}>
            Já tenho conta? Fazer login
          </button>
        </p>

        <div className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
          <Shield className="h-3.5 w-3.5" />
          <span>Seus dados são protegidos e não serão compartilhados com terceiros.</span>
        </div>
      </div>
    </div>);

};

export default Step1AdminData;